export const ALL_VALUE = 'All';
export const DESC = 'DESC';
export const ACTIVE = 'Active';
export const INACTIVE = 'Inactive';
export const DISABLE = 'Disable';
export const ENABLE = 'Enable';
export const DISABLED = 'Disabled';
export const ENABLED = 'Enabled';
// filters
export const ALL_STORAGE = 'All storage';
export const ALL_STATUSES = 'All statuses';
export const ALL_HEALTH_STATUSES = 'All health statuses';
export const STORAGE = 'Storage';
export const STATUS = 'Status';
export const HEALTH_STATUS = 'Health status';

// ids
export const BACKUPS_HISTORY_ID = 'backups_history';
export const ID_DUMPS_HISTORY_ID = 'id_dumps_history';
export const SCHEDULE_VALIDATOR_BACKUPS = 'schedule_validator_backups';
export const SCHEDULE_VALIDATOR_ID_DUMPS = 'schedule_validator_id_dumps';
